import Vue from "vue";
import { QuantityInputComponentMinicart } from "./quantityInputComponentMinicart";

/**
 * MiniCart Quantity Component
 */
const QuantityInputMinicart = Vue.component("quantity-input-minicart", {
    template: `
    <div class="ct-tile-quantity" :data-pid="item.id">
        <input type="hidden" class="add-to-cart-url" :value="resources.addProductAction" />

        <div class="d-none tile-delete-confirmation-btn"
            :data-pid="item.id"
            :data-delay-time="item.confirmationDelayTime"
            :data-in-cart-msg="resources.inCartLabel"
            :data-one-product-added="resources.inCartOneProduct"
            :data-remove-from-cart-msg="resources.removeFromCartLabel"
            :data-stay-open="resources.confirmationPopupDuration"
            :data-confirmation-image="item.confirmationImage ? JSON.stringify(item.confirmationImage) : ''"
        ></div>

        <quantity-input-component-minicart :resources="resources" :item="item" :quantityInputIcons="quantityInputIcons" />

        <input class="quantity-value-mask d-none" name="quantity" type="number" min="0" value/>
    </div>
    `,
    props: ["resources", "item", "quantityInputIcons"],
    components: {
        QuantityInputComponentMinicart
    }
});

export { QuantityInputMinicart };
